import { MessageRequest } from "../constants/protoTable";

export default abstract class BaseHandler<MT, MR = MessageRequest> {
  protected readonly response: MT;
  protected readonly request?: MR;

  constructor(response: MT, request?: MR) {
    this.response = response;
    this.request = request;
  }

  abstract handle(): any;
}
